import { z } from "zod"
import {
  CommunicationChannel,
  CommunicationTemplateStatus,
} from "@mimber/schema"

export const UpdateCommunicationTemplateSchema = z.object({
  name: z.string().min(1).max(255),
  subject: z.string().min(1).max(255),
  content: z.string().min(1),
  channel: z.nativeEnum(CommunicationChannel),
  status: z.nativeEnum(CommunicationTemplateStatus),
})

export type UpdateCommunicationTemplateFormData = z.infer<
  typeof UpdateCommunicationTemplateSchema
>
